import { render, staticRenderFns } from "./product-filter-block.vue?vue&type=template&id=797cb9fb&"
import script from "./product-filter-block.vue?vue&type=script&lang=js&"
export * from "./product-filter-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports